<template>
  <BaseLayout>
    <div class="page-single">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col class=" col-login">
            <div class="text-center mb-4">
              <a
                target="_blank"
                href="https://www.smartology.net/"
              >
                <img
                  src="/images/logo.png"
                  class="h-7 header-brand-img mr-0"
                  alt="Smartology"
                >
              </a>
            </div>
            <b-form
              class="card"
              @submit.prevent="confirm"
            >
              <div class="card-body p-6">
                <div
                  class="card-title"
                  data-test="register-title"
                >
                  Enter the verification code we emailed to you
                </div>
                <b-form-group
                  id="email-address-group-1"
                  label="Email address:"
                  label-for="email-address-input"
                  label-class="form-label"
                  v-if="showEmailInput"
                >
                  <b-form-input
                    id="email-address-input"
                    v-model="email"
                    type="email"
                    required
                    placeholder="Enter email"
                    autocomplete="off"
                    data-test="email-input"
                  />
                </b-form-group>
                <b-form-group
                  id="verification-group-1"
                  label="Code :"
                  label-for="verification-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="verification-input"
                    v-model="code"
                    type="text"
                    required
                    placeholder="Verification code"
                    autocomplete="off"
                    data-test="code-input"
                    autofocus
                  />
                </b-form-group>
                <div class="form-footer">
                  <b-button
                    data-test="confirm-submit"
                    variant="primary"
                    type="submit"
                    block
                    :disabled="!email || !code || isLoading"
                    :class="{ 'btn-loading': isLoading }"
                  >
                    Sign in
                  </b-button>
                </div>
              </div>
            </b-form>
            <div class="text-center text-muted">
              Didn't receive a verification code?
              <b-button
                data-test="resend-button"
                variant="link"
                @click="resend"
                :disabled="!email"
              >
                Resend
              </b-button>
            </div>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </BaseLayout>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import * as types from '@/modules/authentication/store/types';

export default {
  name: 'ConfirmSignUp',
  data() {
    return {
      email: '',
      code: '',
      error: '',
      showEmailInput: true,
      clicked: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState('authentication', {
      user: 'user',
    }),
  },
  methods: {
    ...mapActions('authentication', [
      types.CONFIRM_SIGN_UP,
      types.RESEND_SIGN_UP,
    ]),
    confirm() {
      if (this.clicked) return;
      this.clicked = true;
      this.isLoading = true;
      this.CONFIRM_SIGN_UP({ email: this.email, code: this.code })
        .then(() => {
          this.clicked = false;
          this.isLoading = false;
          this.$router.push(this.$route.query.redirect
            ? `/login?redirect=${this.$route.query.redirect}`
            : '/login');
        })
        .catch(() => {
          this.clicked = false;
          this.isLoading = false;
        });
    },
    resend() {
      this.RESEND_SIGN_UP(this.email);
    },
  },
  created() {
    this.showEmailInput = this.user ? !this.user.email : true;
    if (!this.showEmailInput) {
      this.email = this.user.email;
    }
  },
};
</script>
